'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = function (array) {
  if (!Array.isArray(array)) {
    throw new TypeError("Expected an array, got ".concat(typeof array));
  }

  array = _toConsumableArray(array);

  for (var index = array.length - 1; index > 0; index--) {
    var newIndex = Math.floor(Math.random() * (index + 1));
    var _ref = [array[newIndex], array[index]];
    array[index] = _ref[0];
    array[newIndex] = _ref[1];
  }

  return array;
};